import _ from 'lodash';
import config from '~/config';
import { log } from '@swiper/core';
import * as hooks from '../hooks';

export default function configureServices( app ) {
  [
    'Cards',
    'Config',
    'Errors',
    // 'Events',
    'Friends',
    'Guests',
    'Info',
    'Members',
    'Memberships',
    'People',
    'Presence',
    'Sessions',
    'Stations',
    'Swipes',
  ].forEach( className => {
    const name = className.toLowerCase();
    const path = `/api/${name}`;
    const conf = config.get( name, {} );
    const svcname = `${className}Service`;
    try {
      const mod = require( `./${svcname}` );
      const ServiceClass = mod[ svcname ];
      const model = new ServiceClass( conf );
      app.use( path, model );
      if ( mod.hooks ) applyHooks( app.service( path ), mod.hooks );
    } catch( err ) {
      log.error( `Error loading service ${name}:`, err );
      throw err;
    }
  } );
}

function applyHooks( service, types ) {
  service.hooks( _.mapValues( types, ( methods, type ) => {
    // type is before/after/error
    if ( _.isArray( methods ) ) methods = { all : methods };
    if ( ! _.isPlainObject( methods ) ) {
      throw new Error( `Invalid hooks ${service.name}.${type}` );
    }
    return _.mapValues( methods, ( funcs, method ) => {
      // method is get/create/update/patch/remove
      return _.flatMap( _.flattenDeep( [ funcs ] ), func => {
        if ( typeof func === 'function' ) return func;
        if ( _.isString( func ) && _.isFunction( hooks[ func ] ) ) {
          return hooks[ func ]();
        }
        throw new Error(
          `Invalid hook ${service.name}.${type}.${method} = ${func}`,
        );
      } );
    } );
  } ) );
}

